import React, { useContext } from 'react';

import { Group } from '@lumapps/groups/types';
import { isSectionNode } from '@lumapps/navigation/types';

import type { NavigationAdminConfiguration } from '../types';

/* These fields are set by the Provider. For page-specific configuration fields, see NavigationAdminConfiguration */
export interface NavigationAdminConfigurationContextType extends NavigationAdminConfiguration {
    /** Whether at least one filter should be displayed */
    hasFilters?: boolean;
    /**
     * Information of the default user feeds.
     * Useful for filtering to detect whether a feed a specific visibility rights.
     */
    defaultFeeds?: {
        publicFeed?: Pick<Group, 'id' | 'name'>;
        allFeed?: Pick<Group, 'id' | 'name'>;
    };
}

/** The default values of the configuration context, if no or partial context is passed */
export const defaultNavigationAdminConfiguration = {
    hasFilters: false,
    availableFilters: {},
    availableEditableNodeFields: {},
    defaultFeeds: {
        publicFeed: undefined,
        allFeed: undefined,
    },
    isListNode: isSectionNode,
    shouldOpenEmptySectionsOnInit: true,
    fetchAtInstanceLevel: true,
    validateExternalUrl: true,
};

/**
 * Create a context to share all the static configuration of this navigation.
 * This is the data that won't change while the user interacts with the navigation admin.
 * */
export const NavigationAdminConfigurationContext = React.createContext<NavigationAdminConfigurationContextType>(
    defaultNavigationAdminConfiguration,
);

/** Hook to get the Navigation Admin Configuration Context */
export const useNavigationAdminConfiguration = () => {
    return useContext(NavigationAdminConfigurationContext);
};
